export default {
  type: 'FeatureCollection',
  name: 'Yellow Zones',
  crs: {
    type: 'name',
    properties: {
      name: 'urn:ogc:def:crs:OGC:1.3:CRS84',
    },
  },
  features: [
    {
      type: 'Feature',
      properties: {
        Name: 'Солонка',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.953586, 49.740643],
            [23.952813, 49.740199],
            [23.951698, 49.740033],
            [23.951955, 49.739034],
            [23.950496, 49.737703],
            [23.951182, 49.737703],
            [23.951526, 49.736594],
            [23.953242, 49.736427],
            [23.954873, 49.735595],
            [23.956075, 49.735762],
            [23.966546, 49.735595],
            [23.980107, 49.739423],
            [24.007058, 49.743527],
            [24.011865, 49.741974],
            [24.01813, 49.734874],
            [24.031949, 49.734264],
            [24.032464, 49.73737],
            [24.038558, 49.738702],
            [24.050539, 49.752663],
            [24.049938, 49.753439],
            [24.049252, 49.753217],
            [24.048347, 49.754667],
            [24.047964, 49.755269],
            [24.045561, 49.754714],
            [24.045046, 49.755158],
            [24.043844, 49.755102],
            [24.042828, 49.75717],
            [24.041956, 49.758928],
            [24.042729, 49.759372],
            [24.042986, 49.760481],
            [24.042168, 49.760431],
            [24.041441, 49.76037],
            [24.039896, 49.7673],
            [24.034418, 49.767873],
            [24.026456, 49.768452],
            [24.022508, 49.76873],
            [24.020792, 49.768868],
            [24.018817, 49.768924],
            [24.01444, 49.769201],
            [24.011993, 49.769283],
            [24.009548, 49.769478],
            [24.006114, 49.769755],
            [23.996834, 49.77125],
            [23.988241, 49.773909],
            [23.983091, 49.773743],
            [23.98309, 49.770085],
            [23.981632, 49.769697],
            [23.98558, 49.766648],
            [23.983349, 49.761658],
            [23.981374, 49.760716],
            [23.974594, 49.759773],
            [23.974614, 49.754841],
            [23.993926, 49.758223],
            [23.994784, 49.755063],
            [23.986545, 49.753454],
            [23.98869, 49.748796],
            [23.969894, 49.740366],
            [23.960967, 49.739534],
            [23.953586, 49.740643],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Малечковичі',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.935522, 49.754178],
            [23.937668, 49.751212],
            [23.940408, 49.749983],
            [23.937297, 49.748056],
            [23.93859, 49.741561],
            [23.953586, 49.740643],
            [23.960967, 49.739534],
            [23.96876, 49.740202],
            [23.98869, 49.748796],
            [23.986545, 49.753454],
            [23.994784, 49.755063],
            [23.993926, 49.758223],
            [23.974614, 49.754841],
            [23.974594, 49.759773],
            [23.972963, 49.760105],
            [23.957194, 49.75892],
            [23.952517, 49.760832],
            [23.949684, 49.757852],
            [23.946187, 49.755565],
            [23.945114, 49.756396],
            [23.93947, 49.753472],
            [23.937389, 49.754941],
            [23.935522, 49.754178],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Басівка',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.881985, 49.783613],
            [23.877106, 49.778375],
            [23.901984, 49.77807],
            [23.904322, 49.775299],
            [23.90694, 49.748048],
            [23.9292, 49.756205],
            [23.932597, 49.753431],
            [23.935522, 49.754178],
            [23.937389, 49.754941],
            [23.938492, 49.754298],
            [23.93947, 49.753472],
            [23.942685, 49.755008],
            [23.943959, 49.75583],
            [23.945114, 49.756396],
            [23.946187, 49.755565],
            [23.949684, 49.757852],
            [23.955328, 49.764835],
            [23.962835, 49.773521],
            [23.944553, 49.777124],
            [23.947214, 49.781614],
            [23.944234, 49.783501],
            [23.942235, 49.789039],
            [23.938236, 49.78968],
            [23.929539, 49.792059],
            [23.930912, 49.794054],
            [23.927454, 49.796412],
            [23.922243, 49.796186],
            [23.915544, 49.792811],
            [23.905867, 49.791454],
            [23.890452, 49.793004],
            [23.886261, 49.78853],
            [23.881985, 49.783613],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Конопниця',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.855213, 49.828991],
            [23.851823, 49.817418],
            [23.848862, 49.815203],
            [23.848862, 49.814843],
            [23.848518, 49.814483],
            [23.845858, 49.814178],
            [23.845557, 49.813818],
            [23.845342, 49.809636],
            [23.850879, 49.807088],
            [23.85178, 49.806064],
            [23.851565, 49.805261],
            [23.860062, 49.804762],
            [23.859376, 49.805731],
            [23.865985, 49.805704],
            [23.867144, 49.808418],
            [23.868045, 49.808501],
            [23.870319, 49.808279],
            [23.89343, 49.80825],
            [23.893171, 49.816685],
            [23.89081, 49.818706],
            [23.885532, 49.817294],
            [23.885489, 49.819786],
            [23.871756, 49.817709],
            [23.868002, 49.817141],
            [23.869289, 49.820575],
            [23.868924, 49.820616],
            [23.869653, 49.82117],
            [23.869332, 49.82362],
            [23.868752, 49.829338],
            [23.863173, 49.82978],
            [23.863066, 49.828742],
            [23.862915, 49.82704],
            [23.858753, 49.827234],
            [23.858818, 49.828853],
            [23.855213, 49.828991],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Суховоля',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.845557, 49.813818],
            [23.845858, 49.814178],
            [23.848518, 49.814483],
            [23.8488572, 49.8147597],
            [23.848862, 49.815203],
            [23.851823, 49.817418],
            [23.855213, 49.828991],
            [23.858818, 49.828853],
            [23.858881, 49.829393],
            [23.860426, 49.831331],
            [23.858967, 49.834071],
            [23.860984, 49.835953],
            [23.857398, 49.835964],
            [23.857226, 49.841388],
            [23.8518538, 49.8403659],
            [23.8465323, 49.8411409],
            [23.8434424, 49.8434656],
            [23.8360609, 49.8451261],
            [23.8310827, 49.8440191],
            [23.8254179, 49.8443512],
            [23.8168349, 49.8426907],
            [23.8166632, 49.8395356],
            [23.826877, 49.8349963],
            [23.8322844, 49.8300136],
            [23.8308253, 49.8249197],
            [23.8372626, 49.8187177],
            [23.8338293, 49.8161148],
            [23.8229288, 49.8176101],
            [23.8220705, 49.8137888],
            [23.8455131, 49.8131795],
            [23.845557, 49.813818],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Бірки',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.930488, 49.917334],
            [23.92993, 49.919157],
            [23.930789, 49.921865],
            [23.929287, 49.923882],
            [23.926368, 49.925982],
            [23.923751, 49.925429],
            [23.922892, 49.926092],
            [23.91903, 49.92601],
            [23.915039, 49.924297],
            [23.913108, 49.921754],
            [23.91182, 49.92134],
            [23.911004, 49.920816],
            [23.91109, 49.919185],
            [23.910447, 49.915758],
            [23.904739, 49.908628],
            [23.910061, 49.906694],
            [23.91388, 49.90686],
            [23.917914, 49.905726],
            [23.916884, 49.90404],
            [23.924289, 49.900856],
            [23.926692, 49.905168],
            [23.92695, 49.906992],
            [23.92386, 49.9097],
            [23.924804, 49.910751],
            [23.924718, 49.911856],
            [23.92592, 49.91263],
            [23.926349, 49.913901],
            [23.930488, 49.917334],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Дубляни',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.0682609, 49.9107449],
            [24.0675742, 49.9048855],
            [24.0680892, 49.9017898],
            [24.0740115, 49.9015133],
            [24.0738399, 49.8975327],
            [24.079333, 49.8971457],
            [24.0827662, 49.8993019],
            [24.0875728, 49.8999101],
            [24.0913493, 49.8962058],
            [24.0888602, 49.8895706],
            [24.093694, 49.890907],
            [24.0974433, 49.8927777],
            [24.0916926, 49.8933306],
            [24.0925509, 49.8962611],
            [24.0924651, 49.897588],
            [24.0971858, 49.8995784],
            [24.0970141, 49.9026743],
            [24.0988166, 49.9048303],
            [24.0973575, 49.9062675],
            [24.0981299, 49.9082022],
            [24.0930659, 49.9092525],
            [24.0743548, 49.9110765],
            [24.0682609, 49.9107449],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Підбірці',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.1172261, 49.8494833],
            [24.118849, 49.843759],
            [24.125008, 49.844036],
            [24.1247505, 49.84296],
            [24.1381831, 49.841853],
            [24.1382689, 49.8402201],
            [24.1447491, 49.8397495],
            [24.1455645, 49.8412994],
            [24.166593, 49.8394866],
            [24.1674513, 49.840649],
            [24.1685671, 49.8433059],
            [24.1690392, 49.8453539],
            [24.1592545, 49.847125],
            [24.1576237, 49.8486746],
            [24.1385264, 49.8496155],
            [24.1346712, 49.8477814],
            [24.1172261, 49.8494833],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Винники',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.077973, 49.807588],
            [24.078488, 49.806148],
            [24.081235, 49.805151],
            [24.081406, 49.801938],
            [24.094648, 49.793073],
            [24.107541, 49.783874],
            [24.123302, 49.779198],
            [24.1341, 49.782391],
            [24.140095, 49.789573],
            [24.142584, 49.793896],
            [24.144902, 49.796388],
            [24.146446, 49.797497],
            [24.148478, 49.798874],
            [24.150108, 49.801256],
            [24.155029, 49.809573],
            [24.155029, 49.810625],
            [24.155973, 49.811068],
            [24.157089, 49.812065],
            [24.158291, 49.814502],
            [24.159235, 49.817327],
            [24.156403, 49.825356],
            [24.157347, 49.830007],
            [24.154772, 49.830284],
            [24.150137, 49.827128],
            [24.128486, 49.826463],
            [24.124216, 49.825855],
            [24.120782, 49.825051],
            [24.119988, 49.824954],
            [24.118466, 49.824969],
            [24.103617, 49.824193],
            [24.101299, 49.822864],
            [24.099754, 49.822809],
            [24.097952, 49.822587],
            [24.093766, 49.82232],
            [24.091363, 49.821102],
            [24.092393, 49.81944],
            [24.089303, 49.815675],
            [24.087414, 49.810468],
            [24.083466, 49.810025],
            [24.081235, 49.810801],
            [24.079175, 49.809914],
            [24.08072, 49.808918],
            [24.079518, 49.807366],
            [24.077973, 49.807588],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Чишки',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.148478, 49.798874],
            [24.149121, 49.798347],
            [24.167661, 49.796574],
            [24.171008, 49.797433],
            [24.170665, 49.796187],
            [24.173025, 49.79458],
            [24.174785, 49.795189],
            [24.174441, 49.796187],
            [24.176244, 49.79627],
            [24.175858, 49.79433],
            [24.17972, 49.794441],
            [24.179977, 49.795937],
            [24.188646, 49.794718],
            [24.188518, 49.79361],
            [24.191221, 49.79361],
            [24.191135, 49.794469],
            [24.195126, 49.794497],
            [24.195169, 49.793416],
            [24.20607, 49.793222],
            [24.205984, 49.794247],
            [24.211778, 49.794137],
            [24.212164, 49.793278],
            [24.214825, 49.793195],
            [24.214825, 49.795937],
            [24.192981, 49.796048],
            [24.192938, 49.797572],
            [24.189333, 49.797212],
            [24.189076, 49.796159],
            [24.178132, 49.797599],
            [24.177574, 49.799012],
            [24.180321, 49.799317],
            [24.179977, 49.800231],
            [24.177488, 49.801588],
            [24.176158, 49.801644],
            [24.175772, 49.800259],
            [24.172338, 49.79843],
            [24.170794, 49.799151],
            [24.150108, 49.801256],
            [24.148478, 49.798874],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Давидів',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.122865, 49.758191],
            [24.120119, 49.757609],
            [24.117415, 49.756527],
            [24.117844, 49.756001],
            [24.119947, 49.75589],
            [24.122136, 49.753755],
            [24.119947, 49.75162],
            [24.128659, 49.747072],
            [24.122994, 49.745464],
            [24.129045, 49.743356],
            [24.134538, 49.741138],
            [24.137371, 49.738919],
            [24.138272, 49.736228],
            [24.141834, 49.737393],
            [24.142306, 49.739141],
            [24.147627, 49.738392],
            [24.147799, 49.737893],
            [24.151061, 49.736811],
            [24.155009, 49.734703],
            [24.156854, 49.735729],
            [24.158614, 49.734842],
            [24.15767, 49.734065],
            [24.159343, 49.733039],
            [24.157798, 49.732373],
            [24.159, 49.731347],
            [24.162948, 49.733233],
            [24.165223, 49.731402],
            [24.166854, 49.732012],
            [24.162862, 49.734592],
            [24.160244, 49.737782],
            [24.156683, 49.740084],
            [24.154151, 49.738808],
            [24.150546, 49.741138],
            [24.151662, 49.74111],
            [24.150202, 49.741609],
            [24.155867, 49.747239],
            [24.151232, 49.748403],
            [24.137156, 49.753367],
            [24.131362, 49.756805],
            [24.125226, 49.760048],
            [24.122865, 49.758191],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        Name: 'Кротошин',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.060496, 49.754049],
            [24.05835, 49.754382],
            [24.050539, 49.752663],
            [24.041548, 49.742355],
            [24.079485, 49.742493],
            [24.072618, 49.739997],
            [24.07425, 49.737833],
            [24.082875, 49.738333],
            [24.085922, 49.737889],
            [24.087639, 49.738555],
            [24.089398, 49.739276],
            [24.088454, 49.740136],
            [24.092188, 49.741134],
            [24.093089, 49.74069],
            [24.107895, 49.740496],
            [24.114933, 49.742355],
            [24.109011, 49.742909],
            [24.113431, 49.747512],
            [24.122994, 49.745464],
            [24.128659, 49.747072],
            [24.119947, 49.75162],
            [24.122136, 49.753755],
            [24.119947, 49.75589],
            [24.117844, 49.756001],
            [24.117415, 49.756527],
            [24.120119, 49.757609],
            [24.122865, 49.758191],
            [24.125226, 49.760048],
            [24.119482, 49.762789],
            [24.114504, 49.764675],
            [24.113645, 49.767225],
            [24.123302, 49.779198],
            [24.104723, 49.769539],
            [24.100857, 49.76509],
            [24.096183, 49.763469],
            [24.091419, 49.763247],
            [24.084678, 49.761181],
            [24.074464, 49.75816],
            [24.060496, 49.754049],
          ],
        ],
      },
    },
  ],
};
